module.exports = __webpack_public_path__ + "img/PS.2c556605.png";